import dayjs from 'dayjs';
import React, {useContext, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import styled, {ThemeContext} from 'styled-components';
import images from '../config/images';


const HeaderWrapper = styled.table`
    width: 100%;
    height: ${props => props.theme.scale * 215}px;
    background-color: ${props => props.theme.white};
    position: relative;

    ${props => (props.theme.colorTheme === 'dark') ? `background-color: ${props.theme.darkShade1};` : `background-color: ${props.theme.white};`}
`;

const Logo = styled.img`
    height: ${props => props.theme.scale * 140}px;
    max-width: ${props => props.theme.scale * 260}px;
    position: absolute;
    left: ${props => props.theme.scale * 40}px;
    top: ${props => props.theme.scale * 32}px;
`;

const Info = styled.div`
    position: absolute;
    right: ${props => props.theme.scale * 32}px;
    top: ${props => props.theme.scale * 32}px;
    display: flex;    
    font-size:  ${props => props.theme.scale * 26}px;
    ${props => (props.theme.colorTheme === 'dark') ? `color: ${props.theme.white};` : `color: ${props.theme.black};`}
`;

const Place = styled.div`
    font-family: 'MuseoSans-900';
    color: ${props => props.theme.place};
    margin-right: ${props => props.theme.scale * 20}px;
    font-size:  ${props => props.theme.scale * 24}px;
`;

const Date = styled.div`
    font-family: 'MuseoSans-300';
    margin-right: ${props => props.theme.scale * 10}px;
    font-size:  ${props => props.theme.scale * 26}px;
    ${props => (props.theme.colorTheme === 'dark') ? `color: ${props.theme.white};` : `color: ${props.theme.black};`}
`;

const Time = styled.div`
    font-family: 'MuseoSans-300';
    margin-left: ${props => props.theme.scale * 10}px;
    font-size: ${props => props.theme.scale * 26}px;
    ${props => (props.theme.colorTheme === 'dark') ? `color: ${props.theme.white};` : `color: ${props.theme.black};`}
`;

const Table = styled.table`
    table-layout: fixed;
    width: 100%;
    overflow: hidden
`;

const ResultLine = styled.tr`
    height: 7em;
`;

const Number = styled.td`
    position: absolute;
    bottom: 2.3em;
    right: 44em;
    width: 5%;
    text-align: right;

    margin-left: auto;
    margin-right: auto;

    ${props => (props.theme.colorTheme === 'dark') ? `color: ${props.theme.white};` : `color: ${props.theme.black};`}
`;

const LineNumber = styled.div`
    border-radius: 50%;
    width: 2.2em;
    height: 2.2em;

    display: flex;
    align-items: center;
    justify-content: center;

    text-align: center;
    margin: auto;
    font-size: 2em;

    padding: 0.2em;
    word-break: break-word;
    font-family: "MuseoSans-900";

    ${props => (props.theme.colorTheme === 'dark') ? `color: ${props.theme.black}; background: ${props.theme.white};` : `color: ${props.theme.white}; background: ${props.theme.black};`}
`;

const LineNumber2 = styled.div`
    border-radius: 50%;
    width: 4em;
    height: 4em;

    display: flex;
    align-items: center;
    justify-content: center;

    text-align: center;
    margin: auto;
    font-size: 1.3em;

    padding: 0.2em;
    word-break: break-word;
    font-family: "MuseoSans-900";

    ${props => (props.theme.colorTheme === 'dark') ? `color: ${props.theme.black}; background: ${props.theme.white};` : `color: ${props.theme.white}; background: ${props.theme.black};`}
`;

const Direction = styled.td`
    position: absolute;
    width: 37%;
    right: 18em;
    top: 8.5em;
    font-size: 14px;
    text-align: left;
    margin-left: auto;
    margin-right: auto;
    ${props => (props.theme.colorTheme === 'dark') ? `color: ${props.theme.white};` : `color: ${props.theme.black};`}
`;

const DirectionNote = styled.td`
    position: absolute;
    width: 37%;
    right: 18em;
    top: 7.7em;
    font-size: 14px;
    text-align: left;
    margin-left: auto;
    margin-right: auto;
    ${props => (props.theme.colorTheme === 'dark') ? `color: ${props.theme.white};` : `color: ${props.theme.black};`}
`;

const LineDirection = styled.div`
    font-size: 1.8em;
    font-family: "MuseoSans-700";
    ${props => (props.theme.colorTheme === 'dark') ? `color: ${props.theme.white};` : `color: ${props.theme.black};`}
`;

const TravelNote = styled.div`
    font-size: 1.3em;
    font-family: "MuseoSans-300";
    float:left;
    margin-right:1em;
    ${props => (props.theme.colorTheme === 'dark') ? `color: ${props.theme.white};` : `color: ${props.theme.black};`}
`;

const PictoInfo = styled.div`
    border-bottom: 1px solid #000;
    text-align: center;
    vertical-align: middle;
    align-items: center;
`;

const PMR = styled.img`
    height: 3.5em;
    max-width: ${props => props.theme.scale * 300}px;
    position: absolute;
    right: 10.5em;
    top: 5em;
`;

const Traffic = styled.img`
    height: 3em;
    max-width: ${props => props.theme.scale * 300}px;
    position: absolute;
    right: 11em;
    top: 9em;
    ${props => (props.theme.colorTheme === 'dark') ? `color: ${props.theme.white};` : `color: ${props.theme.black};`}
`;

const InfoIcon = styled.img`
    height: 3.5em;
    position: absolute;
    right: 11em;
    top: 7em;
`;

const TimeUntil = styled.div`
    position: absolute;
    bottom: 1.35em;
    right: 1em;
    font-family: 'MuseoSans-900';
    font-size: 2.5em;
    ${props => (props.theme.colorTheme === 'dark') ? `color: ${props.theme.white};` : `color: ${props.theme.black};`}
`;

const Bus = styled.div`
    position: absolute;
    bottom: 1.5em;
    right: 1em;
    text-align: right;
`;

const BusComing = styled.img`
    height: 5.5em;
    max-width: ${props => props.theme.scale * 300}px;
    position: absolute;
    right: 3.4em;
    top: 6em;
`;

const Error = styled.div`
    box-sizing: border-box;
    position: absolute;
    top: ${props => props.theme.scale * 100}px;
    right: ${props => props.theme.scale * 30}px;
    text-align: right;
    ${props => (props.theme.colorTheme === 'dark') ? `color: ${props.theme.white};` : `color: ${props.theme.black};`}
`;

const ErrorTitle = styled.div`
    font-size: ${props => props.theme.scale * 34}px;
    font-family: 'MuseoSans-900';
    ${props => (props.theme.colorTheme === 'dark') ? `color: ${props.theme.white};` : `color: ${props.theme.black};`}
`;

const ErrorUrl = styled.div`
    font-size: ${props => props.theme.scale * 30}px;
    font-family: 'MuseoSans-300';
    ${props => (props.theme.colorTheme === 'dark') ? `color: ${props.theme.white};` : `color: ${props.theme.black};`}
`;

const pad = (num, size) => {
    var s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
}

const Header = () => {
    const customer = useSelector(state => state.config.customer);
    const location = useSelector(state => state.config.location);
    const mobilite = useSelector(state => state.data.mobilite);
    const themeContext = useContext(ThemeContext)
    const [time, setTime] = useState(dayjs().format('HH:mm'));
    const [date, setDate] = useState(dayjs().format('DD.MM.YYYY'));

    useEffect(() => {
        let interval = null;
        
        interval = setInterval(() => {
            let newTime = dayjs().format('HH:mm');
            let newDate = dayjs().format('DD.MM.YYYY');
            setTime(newTime);
            setDate(newDate);
        }, 1000);
        
        return () => clearInterval(interval);
    }, [time, date]);

    if (!location) return(null);

    let bus;
    let isThere;
    let busIcon = images.icons.bus;
    let pmr = images.icons.pmr;
    let traffic = images.icons.traffic;
    let logo = images.logos[customer];

    if (themeContext.colorTheme === 'dark') {
        logo = images.logosDark[customer];
        busIcon = images.icons.busDark;
        pmr = images.icons.pmrDark;
        traffic = images.icons.trafficDark;
    }

    if (mobilite) {
        if (mobilite.busList) {

            bus = mobilite.busList[0];
            let time = dayjs(`${bus.date} ${bus.time}`);
            let now = dayjs();
            let diff = time.diff(now,'minute', true);

            if (diff > 0) {
                bus.until = pad(Math.ceil(diff), 2);
                isThere = false;
            }
            else {
                isThere = true;
                bus.until = "00";
            }
        }
        return(
            <HeaderWrapper>
                <Logo src={logo} className="smart-touch__logo" alt="logo" />
                <Info>
                    <Place>{location.mobilite}</Place><Date>{date}</Date>|<Time>{time}</Time>
                </Info>
                {<React.Fragment>
                    <Table>
                        <ResultLine>
                            {bus.lineNumber?.length > 5 ? (
                                <Number>
                                    <LineNumber2>{bus.lineNumber}</LineNumber2>
                                </Number>
                            ) :
                                <Number>
                                    <LineNumber>{bus.lineNumber}</LineNumber>
                                </Number>
                               }
                            {bus.travelnote && bus.travelnote.length > 0 ? (
                              <DirectionNote>
                                <LineDirection>{bus.direction}</LineDirection>
                                <TravelNote>{bus.travelnote[0]}</TravelNote>
                              </DirectionNote>
                            ) : (
                                <Direction>
                                    <LineDirection>{bus.direction}</LineDirection>
                                </Direction>
                            )}
                            {bus.accessiblityFlag == 1 && bus.nextbusLate > 2 ?(
                                <PictoInfo>
                                    <PMR src={pmr} alt="PMR" />
                                    <Traffic src={traffic} alt="Traffic" />
                                </PictoInfo>
                            ):(
                                bus.accessiblityFlag == 1 ?(
                                    <InfoIcon src={pmr} alt="PMR" />
                                ):(
                                bus.nextbusLate > 2 ?(
                                    <InfoIcon src={traffic} alt="Traffic" />
                                ):(
                                    null
                                ))
                            )}
                            {bus.nextbusinMin >= 2 ?(
                                <TimeUntil>{bus.nextbusinMin} min</TimeUntil>
                            ):(
                                <BusComing src={busIcon} alt="incoming bus" />
                            )}
                        </ResultLine>
                    </Table>
                </React.Fragment>}
            </HeaderWrapper>
        )
    }
}

export default Header;